module.exports = __webpack_public_path__ + "images/facility/default-facility-image.jpg";